import React from 'react';

import { Box, Button } from '@mui/material';
import { Role, roleSelectUrl } from './Api';

// Selecting a role is a full-page navigation: the server stores it in the session
// and redirects back to the app, which then reboots with the chosen role active.
export default function RoleSelect({roles, userName}: {roles: Role[], userName: string | null}) {
    return (
        <Box sx={{ p: 2 }}>
            <p>{userName !== null && `${userName}: `}Välj vilken roll du vill arbeta som:</p>
            {roles.map(role => (
                <Button key={role.id} variant="contained" sx={{ m: 0.5 }} href={roleSelectUrl(role.id)}>
                    {role.name}
                </Button>
            ))}
        </Box>
    )
}
